<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M3 3V21H11V19H13V23H1V1H13V5H11V3H3ZM17.34 6.34003L21.59 10.59L23 12L21.59 13.42L17.34 17.66L15.93 16.24L19.17 13H7V11H19.17L15.93 7.76003L17.34 6.34003Z" fill="currentColor"/>
</svg>
